import { useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { FileText } from "lucide-react";

export default function StickyQuote() {
  const location = useLocation();
  const navigate = useNavigate();

  const onClick = () => {
    const el = document.getElementById("contact");
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/");
      setTimeout(() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" }), 500);
    }
  };

  // Hide on the admin dashboard
  if (location.pathname.startsWith("/admin")) return null;

  return (
    <motion.button
      onClick={onClick}
      data-testid="sticky-quote-btn"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 1, duration: 0.6 }}
      className="fixed bottom-6 right-6 z-40 group inline-flex items-center gap-2 rounded-full bg-[#111] text-white font-head font-semibold text-sm pl-5 pr-6 py-3.5 shadow-[0_10px_30px_rgba(0,0,0,0.25)] transition-colors duration-300 hover:bg-[#B08D57]"
    >
      <FileText size={16} />
      Request a Quote
    </motion.button>
  );
}
